import { render, staticRenderFns } from "./FunctionTest.vue?vue&type=template&id=1c924421&scoped=true&"
import script from "./FunctionTest.vue?vue&type=script&lang=js&"
export * from "./FunctionTest.vue?vue&type=script&lang=js&"
import style0 from "./FunctionTest.vue?vue&type=style&index=0&id=1c924421&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c924421",
  null
  
)

export default component.exports